exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.step-approval{display:flex;justify-content:center}.step-approval button{border:none;border-radius:4px;font-size:14px;line-height:18px;padding:8px 16px;width:124px;font-family:Open Sans,sans-serif;font-weight:600;color:#fff;text-transform:uppercase;cursor:pointer}.step-approval button~button{margin-left:.5rem}.step-approval button.reject{background-color:#d0021b}.step-approval button.approve{background-color:#4bb543}.step-approval button.review{background-color:#f5a623}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/TaskCompletionStepsMobile/StepApproval/StepApproval.scss
// module id = 1665
// module chunks = 0